import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { setFeatureToShow } from "./showFeature";
import { FeatureDcExtended } from "../selectFeatures/types";

export const useSetShowFeature = (layerName?: string) => {
  const dispatch = useDispatch();

  return useCallback(
    (feature: FeatureDcExtended) => {
      dispatch(
        setFeatureToShow({
          ...feature,
          layer: layerName,
        }),
      );
    },
    [dispatch, layerName],
  );
};
